export default function fromNumberToPercent(value) {
    if (value === undefined)
        return '';
    if (value === null)
        return '';
    if (Number.isNaN(value))
        return '';
    const result = Intl.NumberFormat([], { style: 'percent' }).format(value);
    return result;
}
